import React from "react";
import { Link } from "react-router-dom";

import { ROUTE_SIM } from "../../../../routes";

import convertDateToString from "../../../../libs/convertDateToString";

import { ReportRows, ReportDetailContainer } from "./styledUserReport";

const MyReportComponent = ({ reports }) => {
  return (
    <>
      {reports?.map((report) => (
        <ReportRows className="w-100 mb-3" key={report.id}>
          <p className="col-12 col-lg-9 p-0 mb-3 mb-lg-0 flex-grow-1">
            گزارش فعالیت آزمایش {report.sim_name}
          </p>
          <ReportDetailContainer className="col-12 col-lg-3 p-0">
            <Link
              to={{
                pathname: `${ROUTE_SIM}${report?.sim}`,
                search: "?tab=lab-report",
                state: {
                  editFromProfile: true,
                  reportID: report.id,
                },
              }}
              className="flex-grow-1 mx-md-3"
            >
              رفتن به گزارش فعالیت
            </Link>
            <div>
              <span>آخرین ویرایش&nbsp;</span>
              <span dir="ltr">
                {convertDateToString("fullNumber", report?.finish_at)}
              </span>
            </div>
          </ReportDetailContainer>
        </ReportRows>
      ))}
    </>
  );
};

export default MyReportComponent;
